import { GET_DATA_SEARCH, SAVE_SEARCH_VALUE } from "../constants";

const initialState = {
  pageNum: 1,
  pageSize: 5,
  totalPage: 0,
  total: 0,
  searchedCerts: [],
};

export default function searchReducer(state = initialState, action) {
  switch (action.type) {
    // Handle Get Post
    case GET_DATA_SEARCH:
      return { ...state, ...action.payload };

    case SAVE_SEARCH_VALUE:
      return { ...state, ...action.payload };

    // Default
    default:
      return state;
  }
}
